import React, { useState } from 'react';

export function DateInput({ style, value, onChange }) {
  const [error, setError] = useState('');

  function handleBlur(e) {
    const val = e.target.value;
    if (!val) { setError(''); return; }
    const year = parseInt(val.split('-')[0], 10);
    if (year < 1000) {
      onChange('');
      setError('Please enter a 4-digit year.');
    } else {
      setError('');
    }
  }

  return (
    <div>
      <input
        type="date"
        style={{ ...style, ...(error ? { borderColor: '#c0392b' } : {}) }}
        value={value}
        onChange={e => { setError(''); onChange(e.target.value); }}
        onBlur={handleBlur}
      />
      {error && (
        <div style={{ fontSize: 12, color: '#c0392b', marginTop: 4 }}>{error}</div>
      )}
    </div>
  );
}

/** "I don't have any" confirmation for an empty list step (Medications,
 * Pharmacy, Doctors). Only shown while the list is empty - the wizard blocks
 * Next until the client either adds something or checks this. */
export function NoneCheckbox({ checked, onChange, label }) {
  return (
    <label style={{
      display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', userSelect: 'none',
      marginTop: 16, padding: '12px 14px', background: '#f4f8fc',
      border: '1.5px solid #c5d5e8', borderRadius: 8,
    }}>
      <input
        type="checkbox"
        checked={Boolean(checked)}
        onChange={e => onChange(e.target.checked)}
        style={{ width: 17, height: 17, cursor: 'pointer', accentColor: '#1a3364', flexShrink: 0 }}
      />
      <span style={{ fontSize: 14, color: '#1a3364', fontWeight: 500 }}>{label}</span>
    </label>
  );
}

export const lbl = {
  display: 'block',
  fontSize: 11,
  fontWeight: 700,
  color: '#1a3364',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  marginBottom: 5,
};

export const inp = {
  width: '100%',
  // Without this, inputs/selects inside CSS Grid columns (row2/row3, and the
  // per-step inline grids) refuse to shrink below their browser-default
  // intrinsic width, forcing 2-3 column rows wider than the screen on
  // mobile - the actual cause of fields overlapping/crowding on narrow
  // viewports rather than each column just shrinking proportionally.
  minWidth: 0,
  padding: '10px 12px',
  border: '1.5px solid #c5d5e8',
  borderRadius: 8,
  fontSize: 15,
  color: '#1a3364',
  background: '#fff',
  outline: 'none',
  display: 'block',
};

export const row2 = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 14,
  marginBottom: 18,
};

export const row3 = {
  display: 'grid',
  gridTemplateColumns: '2fr 1.5fr 2fr',
  gap: 14,
  marginBottom: 18,
};

export const sectionDivider = {
  borderTop: '1.5px solid #dbeef8',
  paddingTop: 20,
  marginBottom: 20,
};

export const sectionHeading = {
  fontSize: 13,
  fontWeight: 700,
  color: '#1a3364',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  marginBottom: 14,
};
